import getAspectData from './getAspectData';

export default getAspectData;
